<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Add Details"
            bc1="App"
            bc2="Currency Payment"
            bc3="Add"
            path="currency-payment-method"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Payment Method </label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <b-form-select
                                v-model="paymentId"
                                name="paymentId"
                                size="sm"
                                class="mt-1"
                                v-validate="'required'"
                                :class="
                                  errorBag.has('paymentId') ? 'is-invalid' : ''
                                "
                                @change="
                                  paymentCodeChange(
                                    paymentMethodRequestData,
                                    paymentId
                                  )
                                "
                              >
                                <b-form-select-option value=""
                                  >Please Select payment Method
                                </b-form-select-option>
                                <b-form-select-option
                                  v-for="(item, index) in paymentMethodRequestData"
                                  :value="item.id"
                                  :key="index"
                                  >{{ item.name }}
                                </b-form-select-option>
                                <b-form-select-option
                                  v-show="
                                    !paymentMethodRequestData
                                  "
                                  value="Please Select Payment Method"
                                ></b-form-select-option>
                              </b-form-select>
                              <small
                                v-show="errorBag.has('paymentId')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("paymentId") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Currency</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <b-form-select
                                v-model="currencyId"
                                v-validate="'required'"
                                name="currencyId"
                                size="sm"
                                class="mt-1"
                                :class="
                                  errorBag.has('currencyId') ? 'is-invalid' : ''
                                "
                              >
                                <b-form-select-option value=""
                                  >Please Select currency
                                </b-form-select-option>
                                <b-form-select-option
                                  v-for="(item, index) in currencyRequestData"
                                  :value="item.id"
                                  :key="index"
                                  >{{ item.name }}
                                </b-form-select-option>
                              </b-form-select>
                              <small
                                v-show="errorBag.has('currencyId')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("currencyId") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
<!--                      <div-->
<!--                        class="col-12"-->
<!--                        v-if="code == '0001' || code == '0002'"-->
<!--                      >-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3 col-form-label">-->
<!--                            <label for="name-icon">Bypass3DS</label>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <input-->
<!--                              class="custom-checkbox"-->
<!--                              type="checkbox"-->
<!--                              v-model="byPass3DS"-->
<!--                              name="bypass3dsCheckbox"-->
<!--                            />-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
                      <!-- add key value field starts -->
                      <div class="col-12" v-if="code == '0002'">
                        <div class="form-group ">
                          <div class="col-sm-3 col-form-label">
                            <label for="symbol-icon">Settings</label>
                          </div>
                          <div class="col-12">
                            <div class="added-field">
                              <div class="col-12">
                                <div class="form-group row">
                                  <div
                                    class="col-sm-3 col-form-label text-right"
                                  >
                                    <label for="name-icon">Bypass3DS</label>
                                  </div>
                                  <div class="col-sm-9">
                                    <div class="">
                                      <input
                                          class="custom-checkbox form-control "
                                          style="margin-top: 0.7rem;"
                                          type="checkbox"
                                          v-model="byPass3DS"
                                          name="bypass3dsCheckbox"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12">
                                <div class="form-group row">
                                  <div
                                    class="col-sm-3 col-form-label text-right"
                                  >
                                    <label for="name-icon">Username</label>
                                  </div>
                                  <div class="col-sm-9">
                                    <div class="input-group">
                                      <input
                                        type="text"
                                        v-model="settings2.userName"
                                        class="form-control"
                                        :class="
                                          errorBag.has('username')
                                            ? 'is-invalid'
                                            : ''
                                        "
                                        name="username"
                                        v-validate="'required'"
                                        placeholder="Username"
                                      />
                                      <small
                                        v-show="errorBag.has('username')"
                                        class="invalid-feedback"
                                        >{{
                                          "*" + errorBag.first("username")
                                        }}</small
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12">
                                <div class="form-group row">
                                  <div
                                    class="col-sm-3 col-form-label text-right"
                                  >
                                    <label for="name-icon">Password</label>
                                  </div>
                                  <div class="col-sm-9">
                                    <div class="input-group">
                                      <input
                                        type="text"
                                        v-model="settings2.password"
                                        id="name-icon"
                                        class="form-control"
                                        v-validate="'required'"
                                        placeholder="Password"
                                        name="password"
                                        :class="
                                          errorBag.has('password')
                                            ? 'is-invalid'
                                            : ''
                                        "
                                      />
                                      <small
                                        v-show="errorBag.has('password')"
                                        class="invalid-feedback"
                                        >{{
                                          "*" + errorBag.first("password")
                                        }}</small
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12">
                                <div class="form-group row">
                                  <div
                                    class="col-sm-3 col-form-label text-right"
                                  >
                                    <label for="name-icon">Customer Name</label>
                                  </div>
                                  <div class="col-sm-9">
                                    <div class="input-group">
                                      <input
                                        type="text"
                                        v-model="settings2.customerName"
                                        id="name-icon"
                                        class="form-control"
                                        v-validate="'required'"
                                        placeholder="Customer Name"
                                        name="customerName"
                                        :class="
                                          errorBag.has('customerName')
                                            ? 'is-invalid'
                                            : ''
                                        "
                                      />
                                      <small
                                        v-show="errorBag.has('customerName')"
                                        class="invalid-feedback"
                                        >{{
                                          "*" + errorBag.first("customerName")
                                        }}</small
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12">
                                <div class="form-group row">
                                  <div
                                    class="col-sm-3 col-form-label text-right"
                                  >
                                    <label for="name-icon"
                                      >Transaction Hint</label
                                    >
                                  </div>
                                  <div class="col-sm-9">
                                    <div class="input-group">
                                      <input
                                        type="text"
                                        v-model="settings2.transactionHint"
                                        class="form-control"
                                        v-validate="'required'"
                                        placeholder="Transaction Hint"
                                        name="transactionHint"
                                        :class="
                                          errorBag.has('transactionHint')
                                            ? 'is-invalid'
                                            : ''
                                        "
                                      />
                                      <small
                                        v-show="errorBag.has('transactionHint')"
                                        class="invalid-feedback"
                                        >{{
                                          "*" +
                                            errorBag.first("transactionHint")
                                        }}</small
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <div class="form-group row">
                                  <div
                                    class="col-sm-3 col-form-label text-right"
                                  >
                                    <label for="name-icon"
                                      >Channel</label
                                    >
                                  </div>
                                  <div class="col-sm-9">
                                    <div class="input-group">
                                      <input
                                        type="text"
                                        v-model="settings2.channel"
                                        class="form-control"
                                        v-validate="'required'"
                                        placeholder="Channel"
                                        name="channel"
                                        :class="
                                          errorBag.has('channel')
                                            ? 'is-invalid'
                                            : ''
                                        "
                                      />
                                      <small
                                        v-show="errorBag.has('channel')"
                                        class="invalid-feedback"
                                        >{{
                                          "*" +
                                            errorBag.first("channel")
                                        }}</small
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <div class="form-group row">
                                  <div
                                    class="col-sm-3 col-form-label text-right"
                                  >
                                    <label for="name-icon"
                                      >Store</label
                                    >
                                  </div>
                                  <div class="col-sm-9">
                                    <div class="input-group">
                                      <input
                                        type="text"
                                        v-model="settings2.store"
                                        class="form-control"
                                        v-validate="'required'"
                                        placeholder="Store"
                                        name="store"
                                        :class="
                                          errorBag.has('store')
                                            ? 'is-invalid'
                                            : ''
                                        "
                                      />
                                      <small
                                        v-show="errorBag.has('store')"
                                        class="invalid-feedback"
                                        >{{
                                          "*" +
                                            errorBag.first("store")
                                        }}</small
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <div class="form-group row">
                                  <div
                                    class="col-sm-3 col-form-label text-right"
                                  >
                                    <label for="name-icon"
                                      >Terminal</label
                                    >
                                  </div>
                                  <div class="col-sm-9">
                                    <div class="input-group">
                                      <input
                                        type="text"
                                        v-model="settings2.terminal"
                                        class="form-control"
                                        v-validate="'required'"
                                        placeholder="Terminal"
                                        name="terminal"
                                        :class="
                                          errorBag.has('terminal')
                                            ? 'is-invalid'
                                            : ''
                                        "
                                      />
                                      <small
                                        v-show="errorBag.has('terminal')"
                                        class="invalid-feedback"
                                        >{{
                                          "*" +
                                            errorBag.first("terminal")
                                        }}</small
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-if="code == '0001'">
                        <div class="form-group ">
                          <div class="col-sm-3 col-form-label">
                            <label for="symbol-icon">Settings</label>
                          </div>
                          <div class="col-12">
                            <div class="added-field">
                              <div class="col-12">
                                <div class="form-group row">
                                  <div
                                      class="col-sm-3 col-form-label text-right"
                                  >
                                    <label for="name-icon">Bypass3DS</label>
                                  </div>
                                  <div class="col-sm-9">
                                    <div class="">
                                      <div class="">
                                        <input
                                            class="custom-checkbox form-control "
                                            style="margin-top: 0.7rem;"
                                            type="checkbox"
                                            v-model="byPass3DS"
                                            name="bypass3dsCheckbox"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12">
                                <div class="form-group row">
                                  <div
                                    class="col-sm-3 col-form-label text-right"
                                  >
                                    <label for="name-icon">Authorization</label>
                                  </div>
                                  <div class="col-sm-9">
                                    <div class="input-group">
                                      <input
                                        type="text"
                                        v-model="settings1.Authorization"
                                        class="form-control"
                                        :class="
                                          errorBag.has('Authorization')
                                            ? 'is-invalid'
                                            : ''
                                        "
                                        name="Authorization"
                                        v-validate="'required'"
                                        placeholder="Authorization"
                                      />
                                      <small
                                        v-show="errorBag.has('Authorization')"
                                        class="invalid-feedback"
                                        >{{
                                          "*" + errorBag.first("Authorization")
                                        }}</small
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>

<!--                              <div class="col-12">-->
<!--                                <div class="form-group row">-->
<!--                                  <div-->
<!--                                    class="col-sm-3 col-form-label text-right"-->
<!--                                  >-->
<!--                                    <label for="name-icon">URL</label>-->
<!--                                  </div>-->
<!--                                  <div class="col-sm-9">-->
<!--                                    <div class="input-group">-->
<!--                                      <input-->
<!--                                        type="text"-->
<!--                                        v-model="settings1.url"-->
<!--                                        class="form-control"-->
<!--                                        v-validate="'required'"-->
<!--                                        placeholder="URL"-->
<!--                                        name="url"-->
<!--                                        :class="-->
<!--                                          errorBag.has('url')-->
<!--                                            ? 'is-invalid'-->
<!--                                            : ''-->
<!--                                        "-->
<!--                                      />-->
<!--                                      <small-->
<!--                                        v-show="errorBag.has('url')"-->
<!--                                        class="invalid-feedback"-->
<!--                                        >{{-->
<!--                                          "*" + errorBag.first("url")-->
<!--                                        }}</small-->
<!--                                      >-->
<!--                                    </div>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-9 offset-sm-3 d-flex">
                        <button
                          type="button"
                          class="btn btn-primary mr-1 d-flex"
                          @click="sendCall"
                          :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Submit
                        </button>
                        <button
                          type="button"
                          class="btn btn-gradient-secondary"
                          @click="
                            $router.push({ name: 'currency-payment-method' })
                          "
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      paymentMethodRequestData: [],
      currencyRequestData: [],
      paymentId: "",
      currencyId: "",
      byPass3DS: "",
      paymentID: "",
      currencyPaymentId: "",
      settings1: {
        Authorization: "",
        url: ""
      },
      settings2: {
        userName: "",
        password: "",
        customerName: "",
        transactionHint: "",
        channel:"",
        store:"",
        terminal:"",
      },
      data: [],
      code: "",
      getPaymentID: [],
      getCurrencyID: [],
      loading: false,
      size: "10px"
    };
  },
  components: {
    CommandIcon
  },
  mounted() {
    setTimeout(() => {
      this.selectPaymentData();
      this.selectCurrencyData();
    }, 1000);
  },
  created() {},
  computed: {
    ...mapGetters({
      CurrencyPaymentData: "getByKey"
    })
  },
  methods: {
    selectPaymentData() {
      this.makeRequest("post", "v1/get-payment-method", {
        flag: "active"
      }, {},false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let data = [];
            data = callResponse.response.data.data;
            this.paymentMethodRequestData = data
            // data.key = "paymentMethodSelect";
            // this.$store.dispatch("set", data);

          }
        }
      });
    },
    selectCurrencyData() {
      this.makeRequest("post", "v1/get-currency", { flag: "active" },{},false).then(
        callResponse => {
          if (!callResponse.error) {
            let code = callResponse.response.data.code;
            if (code == 200) {
              let data = [];
              data = callResponse.response.data.data;
              this.currencyRequestData = data
              // data.key = "currencySelectdata";
              // this.$store.dispatch("set", data);
            }
          }
        }
      );
    },
    paymentCodeChange(data, id) {
      const payment = data.find(item => item.id === id);
      if (payment) {
        this.code = payment.code;
      } else {
        this.code = "";
      }
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let keyValue = [];
          if (this.code === "0002") {
            // keyValue.push({
            //   Bypass3DS: this.byPass3DS,
            //   UserName: this.settings2.userName,
            //   Password: this.settings2.password,
            //   Customer: this.settings2.customerName,
            //   TransactionHint: this.settings2.transactionHint
            // });
            keyValue = {
              Bypass3DS: this.byPass3DS,
              UserName: this.settings2.userName,
              Password: this.settings2.password,
              Customer: this.settings2.customerName,
              TransactionHint: this.settings2.transactionHint,
              Channel: this.settings2.channel,
              Store: this.settings2.store,
              Terminal: this.settings2.terminal,
            }
          } else if (this.code === "0001") {
            keyValue = {
              Bypass3DS: this.byPass3DS,
              Authorization: this.settings1.Authorization,
              // url: this.settings1.url
            }
          }
          // let data = new FormData();
          // data.append("application", "android");
          // data.append("applicationVersion", "1.33");
          // data.append("deviceId", "XXXXXXXXXXXXXXXXXXXXXXXX");
          // data.append("deviceDetail", "android s4 etc");
          // data.append("currencyId", this.currencyId);
          // data.append("paymentMethodId", this.paymentId);
          // data.append("latitude", "");
          // data.append("longitude", "");
          // data.append("flag", "active");
          // data.append("data", JSON.stringify(keyValue));

          let requestData = {
            currencyId : this.currencyId,
            paymentMethodId : this.paymentId,
            flag: 'active',
            data : JSON.stringify(keyValue)
          }

          this.makeRequest("post", "v1/add-currency-payment-method", requestData).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  if (callResponse.response.data.data) {
                    let responseData = callResponse.response.data.data;
                    let storeData = this.$store.getters.getByKey(
                      "currencyPayment"
                    );
                    if (typeof storeData.firstPageData != "undefined") {
                      storeData.firstPageData.data.unshift(responseData);
                      storeData.firstPageData.pagination.total = storeData.firstPageData.pagination.total + 1
                      if(storeData.firstPageData.pagination.perPage < storeData.firstPageData.pagination.total){
                        storeData.firstPageData.data.pop();
                      }
                      storeData.key = "currencyPayment";
                      delete storeData.otherPageData;
                      this.$store.dispatch("set", storeData);
                    }
                    this.$router.push({
                      name: "currency-payment-method",
                      params: { add: true }
                    });
                  }
                } else if (code == 400) {
                  this.loading = false;
                }
              }
            }
          );
        }
      });
    }
  }
};
</script>

<style>

</style>
